"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var endpoint_1 = require("./endpoint");
function expandCruises(cruiseArray) {
    for (var i = 0; i < cruiseArray.length; i++) {
        cruiseArray[i] = {
            id: cruiseArray[i].c,
            routeIndex: cruiseArray[i].r,
            start: cruiseArray[i].b,
            end: cruiseArray[i].e,
            shipID: cruiseArray[i].s,
            airportIDs: cruiseArray[i].a,
            paxConfigs: expandPaxe(cruiseArray[i].p),
        };
    }
    return cruiseArray;
}
function expandPaxe(paxConfigs) {
    var verbosePaxe = {};
    lodash_1.forEach(paxConfigs, function (value, key) {
        verbosePaxe[key] = expandPriceModels(value);
    });
    return verbosePaxe;
}
function expandPriceModels(priceModels) {
    var verbosePM = {};
    lodash_1.forEach(priceModels, function (value, key) {
        var priceModelName;
        switch (key) {
            case 'I':
                priceModelName = 'PREMIUM';
                break;
            case 'P':
                priceModelName = 'PAUSCHAL';
                break;
            case 'S':
                priceModelName = 'SEETOURS';
                break;
            case 'V':
                priceModelName = 'VARIO';
                break;
        }
        verbosePM[priceModelName] = {
            categories: expandCategories(value.c),
            flightPrices: expandFlightPrices(value.f),
        };
    });
    return verbosePM;
}
function expandCategories(categories) {
    var verboseCategories = {};
    lodash_1.forEach(categories, function (value, key) {
        verboseCategories[key] = {};
        verboseCategories[key].amount = value.p;
        if (value.m)
            verboseCategories[key].mandatoryFlight = value.m;
        if (value.s)
            verboseCategories[key].surcharges = lodash_1.map(value.s, function (sur) {
                return { amount: sur.p, type: sur.t };
            });
    });
    return verboseCategories;
}
function expandFlightPrices(flightPrices) {
    var verboseFlightPrices = {};
    lodash_1.forEach(flightPrices, function (value, key) {
        verboseFlightPrices[key] = expandFlightDirections(value);
    });
    return verboseFlightPrices;
}
function expandFlightDirections(flightDirections) {
    var verboseFlightDirections = {};
    lodash_1.forEach(flightDirections, function (value, key) {
        verboseFlightDirections[key] = { amount: value.p };
        if (value.c)
            verboseFlightDirections[key].availableForCategories = value.c;
    });
    return verboseFlightDirections;
}
var transform = function (routes) {
    routes = lodash_1.map(routes, function (route) {
        return {
            name: route.n,
            duration: route.d,
            startHabour: route.b,
            endHabour: route.e,
            regionIDs: route.r,
            routeMap: "https://d1ozq1nmb5vv1n.cloudfront.net/fileadmin/user_upload/dam/" + route.m,
            portImages: lodash_1.map(route.i, function (image) {
                return "https://carol.cruise-api.aida.de/" + image;
            }),
            cruises: lodash_1.map(route.c, function (cruise) {
                var cruisePrices = {};
                for (var priceKey in cruise.p) {
                    cruisePrices[priceKey] = lodash_1.map(cruise.p[priceKey], function (price) {
                        return {
                            amount: price.a,
                            priceModel: price.p,
                            flight: price.f,
                            surcharges: lodash_1.map(price.s, function (surcharge) {
                                return {
                                    type: surcharge.t,
                                    amount: surcharge.a,
                                };
                            }),
                        };
                    });
                }
                return {
                    cruiseID: cruise.i,
                    start: cruise.b,
                    end: cruise.e,
                    ship: cruise.s,
                    airports: cruise.a,
                    prices: cruisePrices,
                };
            }),
        };
    });
    return routes;
};
function getPriceModels(priceModels) {
    if (lodash_1.isArray(priceModels)) {
        return priceModels.join(',');
    }
    if (lodash_1.isNil(priceModels)) {
        return 'VARIO';
    }
    return priceModels;
}
function getItineraries(itineraries) {
    if (lodash_1.isArray(itineraries)) {
        return itineraries.join(',');
    }
    return itineraries;
}
var Iris = /** @class */ (function (_super) {
    __extends(Iris, _super);
    function Iris(stage) {
        return _super.call(this, stage, 'iris') || this;
    }
    Iris.prototype.booking = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = {
                    bookingID: opts.bookingID,
                };
                pathTemplate = '/bookings/{bookingID}';
                query = {
                    lastName: opts.lastName,
                };
                return [2 /*return*/, this.invokePermanentGET(params, pathTemplate, query)];
            });
        });
    };
    Iris.prototype.verificationToken = function (bookingID) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            bookingID: bookingID,
                        };
                        pathTemplate = '/bookings/{bookingID}/verification';
                        query = {};
                        return [4 /*yield*/, this.invokePermanentGET(params, pathTemplate, query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result ? result.token : ''];
                }
            });
        });
    };
    // get cabin descripion and availability
    Iris.prototype.cabin = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = {
                    cruiseID: opts.cruiseID,
                    id: opts.id,
                };
                pathTemplate = '/cruises/{cruiseID}/cabins/{id}';
                query = opts;
                return [2 /*return*/, this.invokeNoCacheGET(params, pathTemplate, query)];
            });
        });
    };
    // get cabin descripions and availability
    Iris.prototype.cabins = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = {
                    cruiseID: opts.cruiseID,
                };
                pathTemplate = '/cruises/{cruiseID}/cabins';
                query = lodash_1.omit(opts, ['cruiseID']);
                return [2 /*return*/, this.invokeShortGET(params, pathTemplate, query)];
            });
        });
    };
    // get details for a specific cruise
    Iris.prototype.cruise = function (id, opts) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = { id: id };
                pathTemplate = '/cruises/{id}';
                query = opts;
                return [2 /*return*/, this.invokeShortGET(params, pathTemplate, query)];
            });
        });
    };
    // search through all available cruises
    Iris.prototype.cruises = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate;
            return __generator(this, function (_a) {
                params = {};
                pathTemplate = '/cruises';
                opts.priceModels = getPriceModels(opts.priceModels);
                if (opts.itineraries) {
                    opts.itineraries = getItineraries(opts.itineraries);
                }
                return [2 /*return*/, this.invokeShortGET(params, pathTemplate, opts)];
            });
        });
    };
    // Parameter onlyNationalities filters countries
    // which are flagged as nationality.
    Iris.prototype.countries = function (onlyNationalities) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = {};
                pathTemplate = '/countries';
                query = {};
                if (onlyNationalities) {
                    query.nationalities = onlyNationalities;
                }
                return [2 /*return*/, this.invokePermanentGET(params, pathTemplate, query)];
            });
        });
    };
    Iris.prototype.country = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = { id: id };
                pathTemplate = '/countries/{id}';
                query = {};
                return [2 /*return*/, this.invokePermanentGET(params, pathTemplate, query)];
            });
        });
    };
    Iris.prototype.insurances = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = {};
                pathTemplate = '/insurances';
                body = req;
                return [2 /*return*/, this.invokePOST(params, pathTemplate, body)];
            });
        });
    };
    // get flights for a specific cruise
    Iris.prototype.flights = function (id, opts) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = { id: id };
                pathTemplate = '/cruises/{id}/flights';
                query = opts;
                return [2 /*return*/, this.invokeShortGET(params, pathTemplate, query)];
            });
        });
    };
    Iris.prototype.railTransport = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = {};
                pathTemplate = '/rail';
                body = req;
                return [2 /*return*/, this.invokePOST(params, pathTemplate, body)];
            });
        });
    };
    Iris.prototype.searchCruisesGrouped = function (paxSettings) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query, result, transformed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {};
                        pathTemplate = '/search/cruises';
                        query = {
                            minified: true,
                        };
                        if (paxSettings) {
                            query.adults = paxSettings.adults | 0;
                            query.juveniles = paxSettings.juveniles | 0;
                            query.children = paxSettings.children | 0;
                        }
                        return [4 /*yield*/, this.invokeShortGET(params, pathTemplate, query)];
                    case 1:
                        result = _a.sent();
                        if (result.errorMessage) {
                            console.log('invalid pax config');
                            return [2 /*return*/, []];
                        }
                        try {
                            transformed = transform(result);
                            return [2 /*return*/, transformed];
                        }
                        catch (err) {
                            console.log('unexpected error: ', err);
                            return [2 /*return*/, []];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Iris.prototype.searchFlightPrices = function (airportCode) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {};
                        pathTemplate = "/catalog/bea/" + airportCode;
                        query = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.invokeShortGET(params, pathTemplate, query)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 3:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Iris.prototype.searchFileAiports = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query, result, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {};
                        pathTemplate = "/catalog/bea/airports";
                        query = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.invokeShortGET(params, pathTemplate, query)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 3:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Iris.prototype.searchFileRegions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query, result, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {};
                        pathTemplate = "/catalog/bea/regions";
                        query = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.invokeShortGET(params, pathTemplate, query)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 3:
                        err_3 = _a.sent();
                        console.log(err_3);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Iris.prototype.searchFileShips = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query, result, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {};
                        pathTemplate = "/catalog/bea/ships";
                        query = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.invokeShortGET(params, pathTemplate, query)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 3:
                        err_4 = _a.sent();
                        console.log(err_4);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Iris.prototype.searchExpinetCatalog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {};
                        pathTemplate = '/catalog/expinet/searchfile';
                        query = {};
                        return [4 /*yield*/, this.invokeShortGET(params, pathTemplate, query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Iris.prototype.exchangeRates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = {};
                pathTemplate = '/exchangeRates';
                query = {};
                return [2 /*return*/, this.invokePermanentGET(params, pathTemplate, query)];
            });
        });
    };
    Iris.prototype.stations = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate;
            return __generator(this, function (_a) {
                params = { name: name };
                pathTemplate = "/rail/stations/{name}";
                return [2 /*return*/, this.invokePermanentGET(params, pathTemplate, {})];
            });
        });
    };
    Iris.prototype.transportations = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = {};
                pathTemplate = '/transportations';
                query = opts;
                return [2 /*return*/, this.invokePermanentGET(params, pathTemplate, query)];
            });
        });
    };
    Iris.prototype.book = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            function doBooking() {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 1000); })];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, that.invokeNoCacheGET({ id: resp.id }, '/book/status/{id}', {})];
                            case 2:
                                resp = _a.sent();
                                _a.label = 3;
                            case 3:
                                if (resp.status === 'REQUESTED') return [3 /*break*/, 0];
                                _a.label = 4;
                            case 4:
                                resolved = true;
                                return [2 /*return*/, resp];
                        }
                    });
                });
            }
            var params, path, resp, timeout, that, resolved;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {};
                        path = '/book';
                        return [4 /*yield*/, this.invokePOST(params, path, opts)];
                    case 1:
                        resp = _a.sent();
                        timeout = 3600;
                        that = this;
                        resolved = false;
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                setTimeout(function () {
                                    if (!resolved) {
                                        resp.errors = [
                                            {
                                                code: '402',
                                            },
                                        ];
                                        resp.status = 'ERROR';
                                        resolve(resp);
                                    }
                                }, 120000);
                                doBooking()
                                    .then(resolve)
                                    .catch(reject);
                            })];
                }
            });
        });
    };
    Iris.prototype.confirmationPdf = function (cruiseID, bookingID, firstName, lastName) {
        return __awaiter(this, void 0, void 0, function () {
            var params, data, pathTemplate, query, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { bookingID: bookingID };
                        data = {
                            c: cruiseID,
                            l: lastName,
                            f: firstName,
                        };
                        pathTemplate = '/bookings/{bookingID}/confirmation';
                        query = { data: new Buffer(JSON.stringify(data)).toString('base64') };
                        return [4 /*yield*/, this.invokePermanentGET(params, pathTemplate, query)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    Iris.prototype.bookRail = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = {};
                pathTemplate = '/rail/book';
                body = { params: req };
                return [2 /*return*/, this.invokePOST(params, pathTemplate, body)];
            });
        });
    };
    Iris.prototype.upgradeCabin = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = {};
                pathTemplate = '/cabin/upgrade';
                body = req;
                return [2 /*return*/, this.invokePOST(params, pathTemplate, body)];
            });
        });
    };
    Iris.prototype.typo3umLogin = function (sessionID) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.invokeNoCacheGET({}, '/typo/login', { sessionID: sessionID })];
            });
        });
    };
    return Iris;
}(endpoint_1.Endpoint));
exports.default = Iris;
//# sourceMappingURL=iris.js.map